import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ScrollTop } from "primereact/scrolltop";
import { Toast } from 'primereact/toast';

import InitLoading from "../../common/InitLoading";
import Header from "./components/Header";
import DraggableMessages from "./components/DraggableMessages";
import NewNotificationBar from "./components/NotificationBar";

import { ALLOWED_PATHS_WITHOUT_TOKEN, BUYER_PORTAL_PATHS, DARK_BACKGROUND_PATHS, NON_HEADER_PATHS } from "../../constants";
import { checkPermissions } from "../../utils";

import './index.css'


function Layout() {
    const [showNotificationAlert, setShowNotificationAlert] = useState(true)
    const location = useLocation()

    const userDetails = useSelector(state => state.userDetails)
    const jwtToken = useSelector((state) => state.userDetails.jwtToken)
    const userDetilsLoadingStatus = useSelector((state) => state.userDetails.loading)
    const notifications = useSelector((state) => state.notifications.notifications)
    const menuData = useSelector((state) => state.menu.menuData)
    // check for permissions
    
    let permittedPathList = []
    if (menuData.length){
        permittedPathList = menuData.filter(eachMenu => {
            if(eachMenu.permActionId && userDetails.activeCompanyRoleId){
                const permParams = {
                    reqPermActionIds: [eachMenu.permActionId],
                    activeCompanyRoleId: userDetails.activeCompanyRoleId,
                    userRoleId: userDetails.activeRoleId,
                    permExceptions: userDetails.permExceptions,
                    permGeo: userDetails.permGeo,
                    permActions: userDetails.permActions,
                    permRoles: userDetails.permRoles
                }
                const permissionDetails = checkPermissions({...permParams, reqPermActionIds: [eachMenu.permActionId]})
                return permissionDetails.isPermitted
            }
            return true
        })
    }
    
    const permittedPaths = permittedPathList.map(eachPathObj => (eachPathObj.clientPath))

    let pathname = location.pathname.replace(/\/\d*$/, '')
    // console.log("pathname", location, location.pathname.replace(/\/\d*$/, ''))

    // console.log("permittedPaths", permittedPaths, permittedPaths.includes(pathname), "pathname", pathname, "location.pathname", location.pathname)

    if(location.pathname === "/"){
        pathname = "/"
    } 

    if(menuData.length && permittedPaths.length > 0 && !permittedPaths.includes(pathname)){
        console.log("menuData.length", menuData.length, permittedPaths.length, !permittedPaths.includes(pathname), pathname)
        console.log("permittedPaths", permittedPaths)
        return <Navigate to="/403" />
    }
    
    if(!jwtToken){
        if(!ALLOWED_PATHS_WITHOUT_TOKEN.includes(pathname)){
            return <Navigate to="/login" replace />
        }
    }

    /*
    if(!jwtToken){
        return <Navigate to="/login" replace />
    }*/

    let layoutBackgroundStyle = {}

    if(BUYER_PORTAL_PATHS.includes(pathname)){
        layoutBackgroundStyle = {
            backgroundColor: "white"
        }
    }

    if(DARK_BACKGROUND_PATHS.includes(pathname)){
        layoutBackgroundStyle = {
            backgroundColor: "#122746"
        }
    }

    const handleNotificationClick = () => {
        // Find and click the notification bell in the header
        const notificationBell = document.querySelector('.notification-bell-button'); // Add this class to your bell button in Header
        if (notificationBell) {
            notificationBell.click();
        }
        setShowNotificationAlert(false);
    };

    return (
        <>
            <div className="layout-wrapper">
                <div className="layout-content" style={layoutBackgroundStyle} >

                    { NON_HEADER_PATHS.includes(pathname) ? null : <Header /> }
                    { userDetilsLoadingStatus ? 
                        <InitLoading visible={userDetilsLoadingStatus} /> 
                        : 
                        <>  
                            { userDetails.activeRoleId ? 
                                <>
                                    <div className="draggable-messages-box"> 
                                        <DraggableMessages />
                                    </div>
                                    {showNotificationAlert && notifications.length > 0 && (
                                        <div className="notification-alert" onClick={handleNotificationClick}>
                                            <div className="notification-content">
                                                <span className="flex align-items-center">
                                                    <i className="pi pi-bell"></i>
                                                    There are unread notifications for you. Please click on bell icon or 
                                                    click here to view.
                                                </span>
                                                <button 
                                                    className="notification-close-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowNotificationAlert(false);
                                                    }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            : null}
                            <Outlet />
                        </>
                    }
                </div>
                <ScrollTop target="window" threshold={300} className="w-2rem h-2rem border-round  border-circle surface-600" icon="pi pi-arrow-up text-base" />
                <ConfirmDialog />
            </div >
        </>
    )
}

export default Layout;